import scissor from "../../assets/imgs/scissor.svg";
import arrobaIcon from "../../assets/imgs/arroba.svg";
import coroa from "../../assets/imgs/coroa.svg";
import { useContext, useEffect, useState } from "react";
import { PostContext } from "../../providers/PostContext";
import { log } from "console";
import { CommentStyled } from "./style";
import { Link } from "react-router-dom";
import { UserContext } from "../../providers/UserContext";

type iComment = {
	id: number;
	message: string;
	like: number;
	dislike: number;
	createdAt: Date;
	updatedAt: Date;
	User: {
		id: number;
		createdAt: Date;
		updatedAt: Date;
		name: string;
		username: string;
		icon: string;
		role: "user" | "admin";
		image?: string;
	};
};

export const Comment = ({
	comment,
	postId,
	page,
}: {
	comment: iComment;
	postId: number | null;
	page: number;
}) => {
	const { likeComment, getTypeLikeComment } = useContext(PostContext);

	const { user } = useContext(UserContext);

	const [like, setLike] = useState(0),
		[dislike, setDislike] = useState(0),
		[typee, setType] = useState<string | void>();

	useEffect(() => {
		if (comment) {
			setLike(comment.like);
			setDislike(comment.dislike);
		}

		if (user) {
			const feachDataTypeLike = async () => {
				const response = await getTypeLikeComment(comment.id);
				setType(response);
			};

			feachDataTypeLike();
		}
	}, []);

	// Função para curtir ou descurtir um comentário
	const handleLikeDislike = async (
		commentId: number,
		type: "like" | "dislike"
	) => {
		try {
			if (type === "like") {
				setLike((prevLike) => prevLike + 1); // Incrementa o número de like
				if (typee) {
					setDislike((prevDislike) => prevDislike - 1);
				}
			} else if (type === "dislike") {
				setDislike((prevDislike) => prevDislike + 1); // Incrementa o número de like
				if (typee) {
					setLike((prevLike) => prevLike - 1);
				}
			}

			setType(type);

			likeComment(commentId, type, postId, page);
		} catch (error) {
			console.error(
				`Erro ao ${type === "like" ? "curtir" : "dar dislike"} no post:`,
				error
			);
		}
	};

	return (
		<CommentStyled>
			<div className="comment">
				<div className="comment-user-info">
					<abbr title={`Perfil de ${comment.User.username}`}>
						<Link to={`/perfil/${comment.User.username}`}>
							<img src={comment.User.image} alt="imagem de perfil" />
						</Link>
					</abbr>
				</div>
				<div className="comment-message">
					<span className="username">
						<img src={arrobaIcon} alt="@" />
						{comment.User.username}
					</span>
					<br />
					{comment.message}
				</div>
				<div className="comment-interact">
					<div>
						<abbr title="Corada">
							<button
								onClick={() => handleLikeDislike(comment.id, "like")}
								disabled={!user || typee === "like"}
							>
								<img src={coroa} alt="like" />
							</button>
						</abbr>
						{like}
					</div>
					<div>
						<abbr title="Tesourada">
							<button
								onClick={() => handleLikeDislike(comment.id, "dislike")}
								disabled={!user || typee === "dislike"}
							>
								<img src={scissor} alt="dislike" />
							</button>
						</abbr>
						{dislike}
					</div>
				</div>
			</div>
		</CommentStyled>
	);
};
